module.exports = __webpack_public_path__ + "static/media/not-supported-saripay.8ac5fadc.svg";